import React, { memo } from 'react'

export const LogoComponent = memo(() => {
	return (
		<>
			<img src="../svg/logoSBER.svg" alt="" />
			<img src="../svg/logoLINE.svg" className="logo-line-sber-ds" alt="" />
			<img src="../svg/logoDS.svg" alt="" />
		</>
	)
})
